import { UsersPage } from "@/components/dashboard/users-page";
import { MailingPage } from "@/components/dashboard/mailing-page";
import { RolesPage } from "@/components/dashboard/roles-page";
import { screenConfigs, type ScreenKey } from "@/lib/dashboard-data";

export function ScreenPage({ screen }: { screen: Extract<ScreenKey, "users" | "mailing" | "roles"> }) {
  if (screen === "users") return <UsersPage config={screenConfigs.users} />;
  if (screen === "mailing") return <MailingPage />;
  return <RolesPage />;
}
